import { useEffect, useRef, useState } from "react";
import MTable from "../../Components/MTable/MTable";
import Select from "react-select";
import {
  getBalanceDashboardData,
  getXenditStagedHistory,
  getXenditStagedHistoryDetail,
} from "../../Service/WithdrawService";
import { NumberFormat } from "../../Components/NumberFormat";
import ReactApexChart from "react-apexcharts";
import { ParseDecimal } from "../../Components/CurrencyInput/ParseDecimal";
import moment from "moment";
import { getUserBranch } from "../../Service/UserService";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import MInput from "../../Components/Core/MInput";
import Modal from "../../Components/Layout/Modal";
import BalanceInquiryDetail from "./BalanceInquiryDetail";
import { useSelector } from "react-redux";

const { $ } = window;

const BalanceInquiry = () => {
  const balanceTableRef = useRef(null);
  const [balance, setBalance] = useState(0);
  const [selectedBalanceState, setSelectedBalanceState] = useState({});
  let { userInfo } = useSelector((state) => state.auth);
  const [chartData, setChartData] = useState({
    series: [
      {
        name: "Series Name",
        data: [], // Initial empty data
      },
    ],
    options: {
      dataLabels: { enabled: false },
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
        },
      },
      xaxis: {
        categories: [], // Initial empty categories
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            return value / 1000000 + "M";
          },
        },
      },
    },
  });
  const [monthlyChartData, setMonthlyChartData] = useState({
    series: [
      {
        name: "Series Name",
        data: [], // Initial empty data
      },
    ],
    options: {
      dataLabels: { enabled: false },
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
        },
      },
      xaxis: {
        categories: [], // Initial empty categories
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            return value / 1000000 + "M";
          },
        },
      },
    },
  });
  const [stores, setStores] = useState([]);
  const [customer, setCustomer] = useState("");
  const [status, setStatus] = useState({ value: "", label: "" });
  const [ordno, setOrderNumber] = useState("");
  const [withdrawalno, setWithdrawalNumber] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dashboardData, setDashboardData] = useState({
    trans_total: 0,
    withdraw_total: 0,
    withdrawal_monthly: 0,
    trans_monthly: 0,
  });
  const defaultSelectedStore = { value: "", label: "" };
  const branchSelectedStore = { value: userInfo.BPLName, label: userInfo.BPLName +':'+ userInfo.BPLFrName};
  const [selectedStore, setSelectedStore] = useState(userInfo.role_name === 'Accounting Staff' ? defaultSelectedStore : branchSelectedStore);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const res = await getUserBranch({activate_paging: "0"}); // Assuming getUserBranch is an async function
        if (res.data) {
          if( userInfo.role_name === 'Sales Consultant' ){
            setStores(res.data.data.filter((store) => store.BPLName === userInfo.BPLName));
          }else{
            setStores(res.data.data); // Do something with the data
          }          
        }
        
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch Stores data. Please try again later.",
        }).then(() => {
          navigate("/");
        });
      }
    };

    const fetchDashboardData = async () => {
      try {
        const res = await getBalanceDashboardData(selectedStore.value); // Assuming getUserBranch is an async function
        if (res.data) {
          setDashboardData(res.data);
          const transTotal = parseInt(res.data?.trans_total);
          const withdrawTotal = parseInt(res.data?.withdrawal_total);
          setBalance(transTotal - withdrawTotal);
          setChartData((prevState) => ({
            ...prevState,
            series: [
              {
                ...prevState.series[0],
                data: res?.data?.daily_transaction?.data || [],
              },
            ],
            options: {
              ...prevState.options,
              xaxis: {
                ...prevState.options.xaxis,
                categories: res?.data?.daily_transaction?.labels,
              },
            },
          }));
          setMonthlyChartData((prevState) => ({
            ...prevState,
            series: [
              {
                ...prevState.series[0],
                data: res?.data?.monthly_transaction?.data,
              },
            ],
            options: {
              ...prevState.options,
              xaxis: {
                ...prevState.options.xaxis,
                categories: res?.data?.monthly_transaction?.labels,
              },
            },
          }));
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch Dashboard data. Please try again later.",
        }).then(() => {
          navigate("/");
        });
      }
    };

    fetchBranches();
    fetchDashboardData();
  }, []);

  const inquiry_table_props = {
    columns: [
      { id: 1, title: "W/D. No.", field: "withdraw_number" },
      { id: 2, title: "Store", field: "withdraw_store" },
      {
        id: 3,
        title: "Order No.",
        field: "reference_id",
        render: (item) => {
          const so_num_split = item.reference_id.split("-");
          const so_num =
            so_num_split[1] + "-" + so_num_split[2] + "-" + so_num_split[3];
          return <span>{so_num}</span>;
        },
      },
      {
        id: 4,
        title: "Trans. Time",
        field: "withdraw_date",
        render: (item) => {
          return (
            <span>
              {moment(item.withdraw_date).format("DD MMM YYYY HH:mm:ss")}
            </span>
          );
        },
      },
      {
        id: 4,
        title: "Cust. Name",
        field: "CardName",
        style: { width: 300 },
      },
      {
        id: 5,
        title: "Order Amt.",
        field: "amount",
        render: (item) => {
          return <span>Rp.{NumberFormat(ParseDecimal(item.amount))},00.</span>;
        },
      },
      {
        id: 5,
        title: "Payment Amt.",
        field: "amount",
        render: (item) => {
          return <span>Rp.{NumberFormat(ParseDecimal(item.amount))},00.</span>;
        },
      },
      {
        id: 6,
        title: "Ref. No.",
        field: "reference_id",
      },
      {
        id: 7,
        title: "Channel",
        render: (item) => {
          return (
            <span>
              {item.payment_method?.replace("_", " ")} - {item.payment_channel}
            </span>
          );
        },
      },
      {
        id: 8,
        title: "Status",
        render: (item) => {
          const badge_type =
            item.withdraw_status == "SUCCESS" ? "success" : "warning";
          return (
            <span>
              <span className={`badge badge-${badge_type}`}>
                {item.withdraw_status}
              </span>
              <a
                onClick={onView(item.reference_id)}
                style={{
                  cursor: "pointer",
                  color: "black",
                  display: "inline-block",
                }}
              >
                <i
                  className="fas fa-eye"
                  style={{ marginRight: "7px", marginTop: "17px" }}
                />
                <span>View</span>
              </a>
            </span>
          );
        },
      },
    ],
    getData: (params) => {
      if (selectedStore && selectedStore.value != "") {
        if (!params.filterAnd)
          params.filterAnd = `withdraw_store:${selectedStore}`;
        else params.filterAnd += `,withdraw_store:${selectedStore}`;
      }

      if (customer) {
        if (!params.filterAnd) params.filterAnd = `CardName:${customer}`;
        else params.filterAnd += `,CardName:${customer}`;
      }

      if (ordno) {
        if (!params.filterAnd) params.filterAnd = `reference_id:${ordno}`;
        else params.filterAnd += `,reference_id:${ordno}`;
      }

      if (withdrawalno) {
        if (!params.filterAnd) params.filterAnd = `withdraw_number:${withdrawalno}`;
        else params.filterAnd += `,withdraw_number:${withdrawalno}`;
      }

      if (status && status.value != "") {
        if (!params.filterAnd)
          params.filterAnd = `withdraw_status:${status.value}`;
        else params.filterAnd += `,withdraw_status:${status.value}`;
      }
      if (status && status.value != "") {
        if (!params.filterAnd)
          params.filterAnd = `withdraw_status:${status.value}`;
        else params.filterAnd += `,withdraw_status:${status.value}`;
      }
      if (startDate) {
        if (!params.filterAnd) params.filterAnd = `start_date:${startDate};>=`;
        else params.filterAnd += `,start_date:${startDate};>=`;
      }
      if (endDate) {
        if (!params.filterAnd) params.filterAnd = `end_date:${endDate};<=`;
        else params.filterAnd += `,end_date:${endDate};<=`;
      }
      return getXenditStagedHistory(params);
    },
    showIndex: true,
    useFilter: false,
    useSearch: false,
    perpage: 10,
  };

  const onView = (id) => async () => {
    try {
      let { data } = await getXenditStagedHistoryDetail(id);
      setSelectedBalanceState({ selectedBalanceDetails: data });
      $("#modalBalanceDetail").modal("show");
    } catch (e) {
      console.log(e);
    }
  };

  let listingBranches = [{
    BPLName:"",
    BPLFrName:""
  },...stores].map((store) => {


    if(store.BPLName == ""){
      return {
        value: "",
        label: "All Stores",
      }
    }
    else {
      return {
        value: store.BPLName,
        label: store.BPLName +':'+ store.BPLFrName,
      }
    }
  }).filter(opt => opt.value.toLowerCase() !== 'main');
  if(userInfo.role_name !== 'Accounting Staff'){
    listingBranches = listingBranches.filter(opt => opt.value === userInfo.BPLName);
  }

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1
                className="title-breadcrum"
                style={{ fontWeight: "300", fontSize: "1.5rem" }}
              >
                Balance Inquiry
              </h1>
              <h2
                className="title-breadcrum"
                style={{ fontWeight: "200", fontSize: "0.9rem" }}
              >
                Details about the current balance based on transaction history
              </h2>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="card shadow mb-4" style={{ padding: "1rem" }}>
            <div className="d-flex" style={{ justifyContent: "space-between" }}>
              <Select
                placeholder="Store"
                options={listingBranches}
                value={stores.find((option) => option.value === selectedStore)}
                onChange={(selected) => {
                  setSelectedStore(selected.value);
                  balanceTableRef.current.refresh();
                }}
                styles={{ container: (base) => ({ ...base, width: "32.5vw" }) }}
              />
              <MInput
                type="date"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                  balanceTableRef.current.refresh();
                }}
                placeholder="Start Date"
                style={{ width: "15vw" }}
              />
              <MInput
                type="date"
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                  balanceTableRef.current.refresh();
                }}
                placeholder="End Date"
                style={{ width: "15vw" }}
              />
              <Select
                placeholder="Status"
                styles={{ container: (base) => ({ ...base, width: "15vw" }) }}
                options={["", "SUCCESS", "PENDING"].map((stats) => {
                  if(stats === ""){
                    return {
                    value: "",
                    label: "All Status"
                    }
                  }else{
                    return {
                    value: stats,
                    label: stats,
                    }
                  }
                })}
                value={[
                  { value: "SUCCESS", label: "SUCCESS" },
                  { value: "PENDING", label: "PENDING" },
                ].find((option) => option.value === status.value)}
                onChange={(selected) => {
                  setStatus(selected);
                  balanceTableRef.current.refresh();
                }}
              />
              
            </div>
            <div className="d-flex" style={{ justifyContent: "flex-start", paddingTop: "17px" }}>
            <input
                style={{
                  paddingLeft: "0.5rem",
                  paddingRight: "0.5rem",
                  border: "1px solid #d1d3e2",
                  width: "15vw",
                  height: "2.5rem",
                }}
                placeholder="Customer Name"
                className="custom-input"
                value={customer}
                onChange={(e) => {
                  setCustomer(e.target.value);
                  balanceTableRef.current.refresh();
                }}
              />
              <input
                style={{
                  paddingLeft: "0.5rem",
                  paddingRight: "0.5rem",
                  marginLeft: "0.25rem",
                  border: "1px solid #d1d3e2",
                  width: "15vw",
                  height: "2.5rem",
                }}
                placeholder="Complete SO Number"
                className="custom-input"
                value={ordno}
                onChange={(e) => {
                  setOrderNumber(e.target.value);
                  balanceTableRef.current.refresh();
                }}
              />
              <input
                style={{
                  paddingLeft: "0.5rem",
                  paddingRight: "0.5rem",
                  marginLeft: "0.25rem",
                  border: "1px solid #d1d3e2",
                  width: "15vw",
                  height: "2.5rem",
                }}
                placeholder="Complete Withdrawal Number"
                className="custom-input"
                value={withdrawalno}
                onChange={(e) => {
                  setWithdrawalNumber(e.target.value);
                  balanceTableRef.current.refresh();
                }}
              />
            </div>
            <div
              className="d-flex"
              style={{
                marginTop: "1.5rem",
                columnGap: "10px",
                justifyContent: "space-between",
              }}
            >
              <div className="bq-card mb-4">
                <div className="card border-left-primary shadow h-100">
                  <div
                    className="card-body d-flex align-items-center"
                    style={{ padding: "0.6rem !important" }}
                  >
                    <div
                      className="d-flex align-items-center"
                      style={{
                        columnGap: "2rem",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          rowGap: "1.2rem",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "0.2rem",
                          }}
                        >
                          <div className="text-sm font-weight-bold text-primary text-uppercase mb-1">
                            Available Balance
                          </div>
                          <div className="h6 mb-0 font-weight-bold text-gray-800">
                            Rp. {NumberFormat(ParseDecimal(balance))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <div className="bq-card card border-left-success shadow">
                  <div
                    className="card-body"
                    style={{ padding: "0.6rem !important" }}
                  >
                    <div
                      className="d-flex align-items-center"
                      style={{
                        columnGap: "2rem",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          rowGap: "1.2rem",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "0.2rem",
                          }}
                        >
                          <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                            Total Transaction
                          </div>
                          <div
                            className="mb-0 font-weight-bold text-gray-800"
                            style={{ fontSize: "0.95rem" }}
                          >
                            Rp.{" "}
                            {NumberFormat(
                              ParseDecimal(dashboardData?.trans_total || 0)
                            )}
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "0.2rem",
                          }}
                        >
                          <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                            Total Withdrawal
                          </div>
                          <div
                            className="mb-0 font-weight-bold text-gray-800"
                            style={{ fontSize: "0.95rem" }}
                          >
                            Rp.{" "}
                            {NumberFormat(
                              ParseDecimal(dashboardData?.withdrawal_total || 0)
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <div className="bq-card card border-left-dark shadow">
                  <div
                    className="card-body"
                    style={{ padding: "0.6rem !important" }}
                  >
                    <div
                      className="d-flex align-items-center"
                      style={{
                        columnGap: "2rem",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          rowGap: "0.8rem",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "0.2rem",
                          }}
                        >
                          <div className="text-xs font-weight-bold text-dark text-uppercase mb-1">
                            Monthly Transaction
                          </div>
                          <div
                            className="h6 mb-0 font-weight-bold text-gray-800"
                            style={{ fontSize: "0.95rem" }}
                          >
                            Rp.{" "}
                            {NumberFormat(
                              ParseDecimal(dashboardData?.trans_monthly || 0)
                            )}
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            rowGap: "0.2rem",
                          }}
                        >
                          <div className="text-xs font-weight-bold text-dark text-uppercase mb-1">
                            Monthly Withdrawal
                          </div>
                          <div
                            className="h6 mb-0 font-weight-bold text-gray-800"
                            style={{ fontSize: "0.95rem" }}
                          >
                            Rp.{" "}
                            {NumberFormat(
                              ParseDecimal(
                                dashboardData?.withdrawal_monthly || 0
                              )
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <div className="bq-card card border-left-warning shadow">
                  <div className="card-body">
                    <div className="row no-gutters align-items-center">
                      <div className="col mr-2">
                        <div className="text-xs font-weight-bold text-warning text-uppercase mb-1">
                          Daily Transaction Chart
                        </div>
                        <div className="h5 mb-0 font-weight-bold text-gray-800">
                          <ReactApexChart
                            options={chartData.options}
                            series={chartData.series}
                            type="bar"
                            height={200}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <div className="bq-card card border-left-danger shadow">
                  <div className="card-body">
                    <div className="row no-gutters align-items-center">
                      <div className="col mr-2">
                        <div className="text-xs font-weight-bold text-danger text-uppercase mb-1">
                          Monthly Transaction Chart
                        </div>
                        <div className="h5 mb-0 font-weight-bold text-gray-800">
                          <ReactApexChart
                            options={monthlyChartData.options}
                            series={monthlyChartData.series}
                            type="bar"
                            height={180}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <MTable {...inquiry_table_props} ref={balanceTableRef} />
            </div>
            <div>
              <Modal id="modalBalanceDetail" modalStyle={{ maxWidth: "700px" }}>
                <BalanceInquiryDetail {...selectedBalanceState} />
              </Modal>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BalanceInquiry;
